<template>
  <div>
    <topsearch :searchForm.sync="listParams" @submit="onSearch" @onClear="onClear" />
    <div class="table">
      <div class="tableBox">
        <div class="title">出证列表</div>
        <etable :list="list" @operate="operate" isIssue />
        <div class="pagination">
          <el-pagination
            :current-page="parm.current"
            :page-sizes="[30, 40, 50, 60]"
            :page-size.sync="parm.size"
            popper-class="paginationTopStyle"
            background
            layout="total,  prev, pager, next, jumper"
            :total="parm.total"
            @size-change="sizeChange"
            @current-change="currentChange"
            :popper-options="{
              placement: 'top',
              boundariesPadding: 10,
            }"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topsearch from "./topsearch.vue";
import getList from "@/mixins/getList";
import etable from "@/views/ElectronicDocuments/etable";
const listParams = {
  keyword: "",
  state: "FINISHED", //合同状态FINISHED
  insuranceState: null, //合同保障状态
  initiated: null, //	合同锁ID
  finishedAt: null, //完成时间
  initiatedAtFrom:null,
  initiatedAtTo:null,
  empUuid: null,
};
export default {
  mixins: [getList],
  components: {
    topsearch,
    etable,
  },
  data() {
    return {
      parm: {},
      listParams: {
        ...listParams,
      },
    };
  },
  mounted() {},
  methods: {
    listApi(parm) {
      console.log(this.listParams)
      return this.$api.getContract({ ...parm, ...this.listParams });
    },
    onClear() {
      this.listParams = { ...listParams };
    },
    operate({ type, data }) {
      if (type == "chuzheng") {
        this.$router.push({
          path: "/thirdPartyServices/issueCertificateList/issueCertificateForm",
          query: { contractId: data.contractId, uuid: data.uuid },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  background: #fff;

  margin-top: 16px;
  border-radius: 6px;
  .tableBox {
    padding: 0 16px;
    .title {
      height: 54px;
      display: flex;
      align-items: center;

      font-weight: 500;
      line-height: normal;
      font-size: 14px;
      color: #262626;
    }
    .pagination {
      @include paginationStyle;
    }
  }
}
</style>
